var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.achievements.length ? _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Achievements')))]), _c('div', {
    staticClass: "px-2 mb-2"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.achievements, function (achievement) {
    return _c('v-col', {
      key: "achievement-".concat(achievement.id),
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('div', {
      staticClass: "px-2 mb-2"
    }, [_c('a', {
      attrs: {
        "href": _vm.$asset.achievement.format(achievement.id) + '.png',
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.achievement.format(achievement.id) + '.png',
        "height": "60",
        "contain": ""
      }
    })], 1)])]);
  }), 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }